import * as React from "react";
import { NavLink } from 'react-router-dom';
import { signOut } from '../../../rest/Login';
import { SignOutCommand } from "../../../login/commands/SignOutCommand";
import { removeAutCookies, redirectToLogin } from "../../../login/commands/configure";
require('./Header.local.css');

const signOutCmd = new SignOutCommand(signOut, removeAutCookies, redirectToLogin);

export class Header extends React.Component<any, any>{

  constructor(props){
    super(props);
    
    this.state = {
      currentUser: JSON.parse(localStorage.getItem('currentUser')),
      polyglot: this.props.polyglot
    }
  }

  navigateToDashboard(){
    this.props.history.push('/dashboard');
  }

  render() {
    const {
      currentUser, polyglot, children
    } = this.state;
    let pathParts = window.location.pathname.split("/");
    let currentPath = pathParts[pathParts.length - 1];
    return (
      <div className="navbar navbar-inverse">
        <div>
          <div className="navbar-header">
            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
              <span className="sr-only"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <a className="navbar-brand" href="#" onClick={this.navigateToDashboard.bind(this)}>
              <img src='https://res.cloudinary.com/dcmnedyx4/image/upload/v1526430686/logo-sps.svg' />
             </a>
          </div>
          <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
              <ul className='nav navbar-nav' {...this.props}>
                {
                  React.Children.map(this.props.children, (child, idx) => {
                    let child_node = this.props.children[idx];
                    return(
                      <li className={child_node.props.navto && child_node.props.navto.indexOf(currentPath) >= 0  ? 'active dropdown open' : 'dropdown'} key={idx}>
                        {child}
                        {child_node.props.subnav}
                      </li>)
                  })
                }
              </ul>
            <ul className="nav navbar-nav navbar-right">
              <li className="dropdown">
                <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                  <img className='avatar-img' src="https://res.cloudinary.com/dcmnedyx4/image/upload/v1526430882/fg-avatar-anonymous-user-retina-7a71ca9109.png" />
                  {<span className="caret"></span>}
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a href="#">
                      <p style={{margin: '0px'}}><i>{polyglot.t('nav.signed_in_as')}</i></p>
                      <p style={{margin: '0px'}}><b>{currentUser.Username}</b></p>
                    </a>
                   </li>
                  <li role="separator" className="divider"></li>
                  <li>
                    <NavLink to={'settings'}>{polyglot.t('nav.settings')}</NavLink>
                  </li>
                  <li role="separator" className="divider"></li>
                  <li><a onClick={signOutCmd.execute}>{polyglot.t('nav.sign_out')}</a></li>
                </ul>
              </li>
            </ul>
         </div>
         <div className="navbar-footer"></div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/components/Header/Header.tsx